import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Text from '../../fields/Text';
import IconWarning from '../../icons/IconWarning';
import IconSearch from '../../icons/IconSearch';
import Button from '../../elements/Button';
import styles from './styles.scoped.css';

export default function SearchRegistrationIdSubUserForm({
  handleSubmit,
  handleReset,
  message,
  code,
  label = 'ID Registrasi',
  buttonLabel = 'Cari Subpangkalan',
}) {
  // const dispatch = useDispatch();
  const { values } = useSelector((state) => state.form.searchRegistrationIdSubUserForm);

  const onSubmit = async (e) => {
    e.preventDefault();
    // dispatch(change('searchRegistrationIdSubUserForm', 'registrationId', ''));
    handleSubmit(values);
  };

  useEffect(() => {
    if (values.registrationId) {
      handleReset();
    }
  }, [values.registrationId]);

  return (
    <form onSubmit={onSubmit}>
      {/* <form> */}
      <label>{label}</label>
      <div className={styles['search-container']}>
        <Field
          component={Text}
          inputProps={{ placeholder: `Masukkan ${label}` }}
          meta={{
            error: message && code !== 401 && (
              <>
                <IconWarning className={styles.icon} color="#CF212A" /> {message}
              </>
            ),
            touched: true,
          }}
          name="registrationId"
        />
        <Button className={styles.btn} disabled={!values.registrationId} type="submit">
          <IconSearch /> {buttonLabel}
        </Button>
      </div>
    </form>
  );
}

SearchRegistrationIdSubUserForm.propTypes = {
  buttonLabel: PropTypes.string,
  code: PropTypes.number,
  handleReset: PropTypes.func,
  handleSubmit: PropTypes.func,
  label: PropTypes.string,
  message: PropTypes.string,
};
